import styled, { css } from "styled-components";

import { Icon, MenuActionLink, StyledBodyText, StyledMenuActionLink } from "@braze/beacon-core";
import { getFontWeight, getInteractionColorBackground, getSemanticColor, getSpacing } from "@braze/beacon-styling";

export const LanguageActionLink = styled(MenuActionLink)<{ active?: boolean }>`
  &${StyledMenuActionLink} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${getSpacing("xs")} 0 ${getSpacing("xs")} ${getSpacing("md")};

    ${StyledBodyText} {
      flex: 1;
    }

    img {
      margin-right: ${getSpacing("md")};
    }
  }

  ${({ active }) =>
    active &&
    css`
      font-weight: ${getFontWeight("bold")};
      background: ${getInteractionColorBackground("hover", "accent", "weak")};

      &&:hover:not(:disabled),
      &&:focus:not(:disabled) {
        background: ${getInteractionColorBackground("hover", "accent", "medium")};
      }

      &&:active:not(:disabled) {
        background: ${getInteractionColorBackground("active", "accent", "medium")};
        outline: none;
      }
    `}
`;

// the color prop absolutely refused to work, so this is the only way to style the icon
export const RestyledIcon = styled(Icon)`
  &&&&& {
    color: ${getSemanticColor("accent-icon-control")};
  }
`;
